import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 83vh;
  display: flex;
  flex-direction: column;
  background: #fff;
`;

export const CollapsiblePanel = styled.div`
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  padding: 16px 0;
`;

export const PanelContent = styled.div<{ collapsed: boolean }>`
  max-height: ${({ collapsed }) => (collapsed ? '40px' : '120px')};
  transition: max-height 0.3s ease;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ToggleButtonWrapper = styled.div`
  margin-bottom: 16px;
`;

export const IframeContainer = styled.div`
  flex: 1;
`;

export const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
`;
